import React from "react";
import { withTranslation } from "react-i18next";
import Table from "../../../components/table/Table";
import Spinner from "../../../components/spinner/Spinner";
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import Ruoli from "../../../utils/Ruoli.json";
import Utils from "../../../utils/Utils";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import SegnalazioniHIVServices from "../../../services/SegnalazioniHIVServices";
import { labelConfig } from "../../../config/labelConfig";

class GestioneDuplicatiHIV extends React.Component {
    state = {
        rows: [],
        totalElements: 0,
        cols: [],
        loading: false,
        page: 0,
        totalPages: 0,
        size: 1000,
        notifiche: [],
        ulssProvenienza: "",
    };

    constructor(props) {
        super(props);
        this.buildParams = this.buildParams.bind(this);
    }

    cols = [
        {
            key: "codiceIndividualePaziente",
            name: "Tables.HomeHiv.paziente",
            sortDirection: "none",
        },
        {
            key: "progressivoRegistro",
            name: "Tables.HomeHiv.id",
            sortDirection: "none",
            tipo: "link",
            path: "/formHIV",
            nomeParametro: "progressivoRegistro",
            state: { currentState: true },
        },
        {
            key: "codiceStruttura",
            name: "Tables.HomeHiv.ulssSegnalazione",
            sortDirection: "none",
        },
        {
            key: "dataSegnalazione",
            name: "Tables.HomeHiv.dataSegnalazione",
            sortDirection: "none",
            tipo: "data",
        },
    ];

    componentDidMount() {
        if (
            SessioneUtente.getInstance().ruoliUtente !==
            Ruoli.Operatore_Regionale.descrizione
        ) {
            this.setState({
                ulssProvenienza: SessioneUtente.getInstance().ulss,
            });
        }

        this.setNavLabel();
        ToasterSingleton.instance().sottoscrizione(this);
        let segnalazioniRequestParam = this.buildParams("codiceIndividualePaziente", "ASC", 0, 1000);
        this.getSegnalazioniHIV(
            Utils.removeEmptyValueFromObject(segnalazioniRequestParam)
        );
    }

    setNavLabel() {
        this.props.navLabel({
            navLabel: {
                label: labelConfig.gestioneDuplicatiHIV[0],
            },
        });
    }

    getSegnalazioniHIV(segnalazioniRequestParam) {
        this.setState({ loading: true });
        SegnalazioniHIVServices.getDuplicatiSegnalazioniHiv(segnalazioniRequestParam).then((data) => {
            const res = SegnalazioniHIVServices.mapGetSegnalazioniHIV(data);
            // get all the results
            let rows = Utils.idSegnalazioneUlss(res);
            const matrix = Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(rows);
            rows = [].concat(...matrix);
            let newState = {
                rows,
                loading: false,
                totalElements: data.data.totalElements,
            };
            this.setState(newState);
        }).catch((e) => {
            console.log(e);
            this.setState({ loading: false });
        });
    }


    buildParams(sort, direction, page, size) {
        return Utils.removeEmptyValueFromObject({
            ulss:
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_HIV.descrizione ||
                SessioneUtente.getInstance().ruoliUtente ===
                    Ruoli.Operatore_Sisp_HIV.descrizione
                    ? SessioneUtente.getInstance().ulss
                    : null,
            sort: sort,
            order: direction,
            page: page,
            size: size
        });
    }

    isUserOperatoreRegionale =
        SessioneUtente.getInstance().ruoliUtente ===
        Ruoli.Operatore_Regionale.descrizione;

    render() {
        const { t } = this.props;
        const matrix = Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(
            this.state.rows
        );
        let length = matrix.length;
        if (!this.isUserOperatoreRegionale) {
            const ulssAppartenenza = SessioneUtente.getInstance().ulss;
            const filteredMatrix = matrix.filter((subList) =>
                subList.find((item) => item.appoStruttura === ulssAppartenenza)
            );
            length = filteredMatrix.length;
        }

        return (
            <div className={"container"}>
                {ToasterSingleton.instance().renderToaster()}
                <div style={{ marginTop: "5rem" }} />
                {this.state.loading && (
                    <div>
                        <Spinner />
                    </div>
                )}
                {length > 0 && (
                    <h6>{`${length} codic${length === 1 ? "e" : "i"} univoc${
                        length === 1 ? "o" : "i"
                    } multipl${length === 1 ? "o" : "i"} rilevat${
                        length === 1 ? "o" : "i"
                    }`}</h6>
                )}
                <div>
                    <Table
                        cols={this.cols}
                        rows={this.state.rows}
                        emptyMsg={t("Tables.HomeHiv.noSegnalazioni")}
                        lengthEditable={true}
                        totalElements={this.state.totalElements}
                        bigTable={true}
                        tableLenght={this.state.size}
                        gestioneDuplicatiHIV={true}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(GestioneDuplicatiHIV);
